import { defineStore } from 'pinia';
import jwtInterceptor from "@/plugins/jwtInterceptor";

export const useRosterStore = defineStore('roster', {
    state: () => ({
        myRoster: [],
        todayRoster: [],
        tomorrowRoster: [],
        dateRoster: [],
        requests: {},
        createdRequest: {},
        requestForms: [],
        upcoming24Production: [],
        workgroups: [],
        skills: [],
        ACTypes: [],
    }),
    getters: {
        getMyRoster(state) {
            return state.myRoster;
        },
        getTodayRoster(state) {
            return state.todayRoster;
        },
        getTomorrowRoster(state) {
            return state.tomorrowRoster;
        },
        getDateRoster(state) {
            return state.dateRoster;
        },
        getRequests(state) {
            return state.requests;
        },
        getCreateRequest(state) {
            return state.createdRequest;
        },
        getRequestForms(state) {
            return state.requestForms;
        },
        getACTypes(state) {
            return state.ACTypes;
        },
        getWorkgroups(state) {
            return state.workgroups;
        },
        getSkills(state) {
            return state.skills;
        },
        filterByValidatedAndReverse: (state) => (validatedValue) => {
            return Object.keys(state.requests)
                .filter((key: string) => {
                    // If validatedValue is undefined, return all entries
                    if (validatedValue === undefined) return true;
                    // Otherwise, filter by the validatedValue
                    return state.requests[key].validated === validatedValue;
                })
                .reverse() // Reverse the order of the filtered keys
                .map(key => ({ key, ...state.requests[key] })); // Return an array of objects containing both key and value
        },
        getUpcoming24Production(state) {
            return state.upcoming24Production;
        },
    },
    actions: {
        loadMyRoster() {
            jwtInterceptor.get('v1/roster/last-quart-and-one-year').then(response => {
                this.myRoster = response.data;
            }).catch(error => {
                console.error(error);
            })
        },
        loadRequests() {
            jwtInterceptor.get('v1/roster/requests').then(response => {
                this.requests = response.data;
            }).catch(error => {
                console.error(error);
            })
        },
        async loadRequestForms() {
            jwtInterceptor.get('v1/roster/requests/forms').then(response => {
                this.requestForms = response.data;
            }).catch(error => {
                console.error(error);
            })
        },
        loadUpcoming24Production() {
            jwtInterceptor.get('v1/roster/for-station-24').then(response => {
                this.upcoming24Production = response.data;
                this.setUniqueFilterOptionsFromDataSet()
            }).catch(error => {
                console.log("problem with loading upcoming 24 production data")
                console.error(error);
            })
        },
        setUniqueFilterOptionsFromDataSet() {
            const acTypes = new Set();
            const skills = new Set();
            const workgroups = new Set();

            for (const shift of this.upcoming24Production) {
                if (shift.User && shift.User.userLicenses) {
                    for (const license of shift.User.userLicenses) {
                        if (license.AcType) {
                            let AcType = license.AcType;
                            if (license.Name) {
                                AcType += ': ' + license.Name;
                            }
                            acTypes.add(AcType);
                        }
                        if (license.Skill) {
                            if(license.Skill !== " ") {
                                skills.add(license.Skill);
                            }
                        }
                    }
                }
                if (shift.User && shift.User.Workgroup) {
                    workgroups.add(shift.User.Workgroup);
                }
            }
            this.ACTypes =  Array.from(acTypes).sort();
            this.skills = Array.from(skills).sort();
            this.workgroups = Array.from(workgroups).sort();
        }
    }
});
